import { render, staticRenderFns } from "./codeModel.vue?vue&type=template&id=200d3e5a&scoped=true"
import script from "./codeModel.vue?vue&type=script&lang=js"
export * from "./codeModel.vue?vue&type=script&lang=js"
import style0 from "./codeModel.vue?vue&type=style&index=0&id=200d3e5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200d3e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200d3e5a')) {
      api.createRecord('200d3e5a', component.options)
    } else {
      api.reload('200d3e5a', component.options)
    }
    module.hot.accept("./codeModel.vue?vue&type=template&id=200d3e5a&scoped=true", function () {
      api.rerender('200d3e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/codeModel.vue"
export default component.exports